module.exports = __webpack_public_path__ + "static/media/Reservation_Layout_JP.4a53279f.docx";